import Typography from "@mui/material/Typography";

export const DefaultLabel = ({ name = "텍스트를 입력해주세요." }) => {
  return (
    <Typography
      variant="body2"
      color="#9A9A9B"
      align="left"
      fontWeight={500}
      sx={{ pb: 1 }}
    >
      {name}
    </Typography>
  );
};
